import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// проверка поддерживаемости структуры данных, хранящихся в локальном хранилище
{
  // версия схемы данных, сохраняющихся в локальном хранилище
  const LocalStorageSchemaVersion = 1;
  const LocalStorageSchemaVersionKey = "LocalStorageSchemaVersion";

  if (localStorage.getItem(LocalStorageSchemaVersionKey) != LocalStorageSchemaVersion.toString())
    localStorage.clear()
  localStorage.setItem(LocalStorageSchemaVersionKey, LocalStorageSchemaVersion.toString());
}

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// /app/SPA/src/main.ts